import React, { Component } from "react";
import PropTypes from "prop-types";
import Select from "react-select";

import {
  Alert,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Row,
  Spinner,
} from "reactstrap";

// Redux
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";

// availity-reactstrap-validation
import { AvField, AvForm } from "availity-reactstrap-validation";
import { browserName } from "react-device-detect";
// actions
import { apiError, loginUser } from "../../store/actions";

// import images
import profile from "../../assets/images/profile-img.png";

import lightlogo from "../../assets/images/logo-mamypoko_1_R.png";
import lightlogo2 from "../../assets/images/pizza-hut/pizza-hut-cap.png";
import logo2 from "../../assets/images/logo-brand.svg";
import login from "../../assets/images/login-img1.png";
import { Country } from "country-state-city";
import Dropdown from "react-bootstrap/Dropdown";
import { toast } from "react-toastify";
import { decryptDataFromArray } from "helpers/EncDec";
import { formatNullUndefined } from "helpers/utils";
import { getClientCredentials } from "helpers/authHelper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-regular-svg-icons";
import { LogoContext } from "../../context/LogoContext";
import api from "../../api";

const generateCaptcha = (length = 5) => {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      showPassword: false,
      otp: "",
      otpStatus: false,
      otpTimer: false, //not in use for now
      errors: undefined,
      Buttonloading: false,
      success: undefined,
      countryData: this.getCountryData(),
      loginType: "username",
      countryCode: "",
      countryCodeError: "",
      hostname: window.location.hostname, // Track the current domain
      captchaText: generateCaptcha(),
      captchaInput: "",
      captchaError: "",
    };

    // handleValidSubmit
    this.handleValidSubmit = this.handleValidSubmit.bind(this);
  }

  refreshCaptcha = () => {
    this.setState({
      captchaText: generateCaptcha(),
      captchaInput: "",
      captchaError: "",
    });
  };

  sendOTP = async () => {
    if (this.state.loginType === "mobile" && this.state.countryCode === "") {
      this.setState({
        countryCodeError: "This Field is Required.",
      });
      return false;
    }

    let ths = this;
    if (!this.state.otpStatus)
      ths.setState({ Buttonloading: true, otpStatus: false });

    let formData = {
      username: this.state.username.trim(),
    };

    if (this.state.loginType === "mobile") {
      (formData.login_from = "mobile"),
        (formData.mobile_country_code = this.state.countryCode);
      formData.adminLogin = true;
    }

    let config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/auth/sendotp`,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify(formData),
    };

    await api(config)
      .then(function (res) {
        let wrong_OTP = res.data.connection_ping;
        console.log("Connection Ping:", wrong_OTP);
        // console.log("OTP:", res.data.test_otp);
        let successmsg =
          ths.state.loginType === "username"
            ? `OTP sent successfully on your username Address.`
            : "OTP sent successfully on your Mobile Number.";
        ths.setState({
          Buttonloading: false,
          otpStatus: true,
          success: [successmsg],
        });
      })
      .catch(function (err) {
        let error;
        if (err.response?.data?.message?.errors) {
          error = err.response?.data?.message?.errors;
        } else {
          error = { username: err.response?.data?.message || err.message };
        }

        ths.setState({
          errors: [error.username],
          Buttonloading: false,
          otpStatus: false,
        });
      });
  };

  onSubmit = async e => {
    e.preventDefault();
    const { captchaText, captchaInput } = this.state;

    if (!captchaInput || captchaInput.toUpperCase() !== captchaText) {
      this.setState({
        captchaError: "Invalid captcha",
      });
      return;
    }
    let ths = this;
    const { history } = this.props;
    this.setState({ Buttonloading: true });

    let formData = {
      username: this.state.username.trim(),
      password: this.state.password.trim(),
      browserName: browserName,
    };
    //console.log('subdomainId',localStorage.getItem("subdomainId"));

    let config = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/admin/auth/login`,
      // url: `http://localhost:5001/authadmin/login`,

      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify(formData),
    };

    await api(config)
      .then(function (res) {
        if (res.status === 200 && res.data.status === "success") {
          ths.setState({ Buttonloading: false });
          console.log("User Id", res.data.user.id);

          localStorage.setItem("authUser", JSON.stringify(res.data));
          localStorage.setItem("auth_token", res.data.accessToken);
          localStorage.setItem("user_info", JSON.stringify(res.data.user));
          localStorage.setItem("user_id", JSON.stringify(res.data.user.id));
          localStorage.setItem("logintime", JSON.stringify(new Date()));
          // console.log(res.data.user, "res.data.user");
          if (ths.state.from) {
            history.push(ths.state.from);
          } else {
            if (res.data.user.role_id == 6) {
              history.push("/cookie-consent-dashboard");
            } else if (res.data.user.role_id == 7) {
              history.push("/sentiment");
            } else if (
              res?.data?.user?.role_name === "agencies" &&
              localStorage.getItem("subdomain") === "mahindra"
            ) {
              history.push("/import-resume");
            } else {
              history.push("/dashboard");
            }
          }
        } else if (res.status === 200 && res.data.status === "fail") {
          ths.setState({ errors: [res.data?.msg] });
        }
      })
      .catch(function (error) {
        console.log("form validation error", error);
        if (error) {
          ths.setState({
            errors: [
              error?.response?.data?.error ||
                error?.response?.data?.msg ||
                "Something Went Wrong",
            ],
          });
        }
      });

    ths.setState({ Buttonloading: false });
  };

  handleSSOLogin = async e => {
    try {
      let clientCreds = getClientCredentials();

      if (!clientCreds) {
        toast.error("Client credentials missing, please reload the page.");

        return;
      }

      let { clientName, clientId, clientSecret, redirectUrl } =
        clientCreds || {};
      let sourceUrl = "Recruit Admin";

      clientName = formatNullUndefined(clientName);
      clientId = formatNullUndefined(clientId);
      clientSecret = formatNullUndefined(clientSecret);
      redirectUrl = formatNullUndefined(redirectUrl);

      if (!(clientName && clientId && clientSecret && redirectUrl)) {
        toast.error(
          "Invalid Client Credentials, Please contact admin for support"
        );

        return;
      }

      window.location.href = `${process.env.REACT_APP_SSO_LOGIN_URL}/accounts/login/redirect?clientId=${clientId}&clientSecret=${clientSecret}&redirectUrl=${redirectUrl}&sourceUrl=${sourceUrl}`;
    } catch (error) {
      toast.error(error?.message || "Error while logging in");
    }
  };

  // handleValidSubmit
  handleValidSubmit(event, values) {
    this.props.loginUser(values, this.props.history);
  }

  componentDidMount() {
    this.props.apiError("");
  }

  handleMobileCountryCodeChange(e) {
    this.setState({
      countryCode: e.value,
      countryCodeError: "",
    });
  }

getCountryData() {
  let countries = [];
  let label, value;

  let countryData = Country.getAllCountries();
  countryData.sort((a, b) => a.name.localeCompare(b.name));

  countryData.forEach(country => {
    value = country.phonecode;
    label = country.name;

    if (!value.startsWith("+") && value.length > 0) {
      value = "+" + country.phonecode;
    }

    if (value.length > 0) {
      if (value.indexOf("and") !== -1) {
        let value_child = value.split(" and ");

        countries.push(
          {
            label: label + " " + value_child[0],
            value: value_child[0],
            countryValue: country.name,
          },
          {
            label: label + " +" + value_child[1],
            value: "+" + value_child[1],
            countryValue: country.name,
          }
        );
      } else {
        countries.push({
          label: label + " " + value,
          value: value,
          countryValue: country.name,
        });
      }
    }
  });

  return countries;
}

  componentDidMount() {
    this.applyThemeBasedOnDomain(); // Apply the theme based on the domain and user selection
  }

  componentDidUpdate(prevProps) {
    // Check if the selected theme has changed
    const selectedTheme = localStorage.getItem("selectedTheme");
    if (selectedTheme !== prevProps.selectedTheme) {
      this.applyThemeBasedOnDomain(); // Reapply the theme when it changes
    }
  }

  // New method to apply the stored theme
  applyStoredTheme = () => {
    const selectedTheme = localStorage.getItem("selectedTheme") || "theme1"; // Default to theme1 if no theme is selected

    // Remove any existing theme class from the body
    document.body.classList.remove("theme1", "theme2", "theme3", "theme4");
    document.body.classList.add(selectedTheme);
  };

  applyThemeBasedOnDomain = () => {
    // Remove any existing theme class from the body
    document.body.classList.remove("theme1", "theme2", "theme3", "theme4");

    // Check for selected theme in localStorage
    const selectedTheme = localStorage.getItem("selectedTheme");

    // Determine domain and apply the corresponding default theme if no selected theme
    const domain = window.location.hostname;
    let newTheme = selectedTheme || "theme1"; // Default to theme1 if no theme is selected

    if (!selectedTheme) {
      if (domain.includes("neuronimbus")) {
        newTheme = "theme1"; // youngunns theme
      } else if (
        domain.includes("dev") ||
        domain.includes("youngunns") ||
        domain.includes("demo")
      ) {
        newTheme = "theme2"; // pizza theme
      } else if (domain.includes("green")) {
        newTheme = "theme3"; // green theme
      } else if (domain.includes("yellow")) {
        newTheme = "theme4"; // yellow theme
      }
    }

    // Apply the theme
    document.body.classList.add(newTheme);
  };

  componentWillUnmount() {
    // Cleanup: Remove theme classes when the component unmounts
    document.body.classList.remove("theme1", "theme2", "theme3", "theme4");
  }

  getUserName() {
    if (localStorage.getItem("authUser")) {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      return obj;
    }
    return null;
  }

  handleThemeChange = themeKey => {
    // Remove the previous theme class from the body
    document.body.classList.remove("theme1", "theme2", "theme3", "theme4");

    // Add the new theme class
    document.body.classList.add(themeKey);

    // Store the selected theme in localStorage
    localStorage.setItem("selectedTheme", themeKey);

    // No need to reload the page, just update the state if necessary
    this.setState({ selectedTheme: themeKey });
  };

  togglePasswordVisibility = () => {
    this.setState(prevState => ({
      showPassword: !prevState.showPassword,
    }));
  };

  render() {
    const { password, showPassword } = this.state;
    return (
      <React.Fragment>
        {/* <div className="home-btn d-none">
          <div className="dropdown-section">
            <Dropdown>
              <Dropdown.Toggle variant="success" id="dropdown-basic">
                <img src={user} alt="" />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item href="#">
                  <div className="theme-buttons">
                    <button
                      className="btn btn-sm blueTheme"
                      onClick={() => this.handleThemeChange("theme1")}
                    ></button>
                    <button
                      className="btn btn-sm redTheme"
                      onClick={() => this.handleThemeChange("theme2")}
                    ></button>
                    <button
                      className="btn btn-sm greenTheme"
                      onClick={() => this.handleThemeChange("theme3")}
                    ></button>
                    <button
                      className="btn btn-sm yellowTheme"
                      onClick={() => this.handleThemeChange("theme4")}
                    ></button>
                  </div>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div> */}
        <div className="account-pages vh-100">
          <Container className="vh-100">
            <Row className="justify-content-center vh-100">
              <Col md={6} lg={6} xl={6} className="login-mobile-img">
                <div className="login-design-img">
                  <img src={login} alt="login img" />
                </div>
              </Col>
              <Col md={6} lg={6} xl={6}>
                <Card className="overflow-hidden">
                  {/* <div className="bg-primary bg-soft">
                    <Row>
                      <Col className="col-7">
                        <div className="text-primary p-4 welcome-cards">
                          <h5 className="text-primary">Welcome Back !</h5>
                          <p>Sign in to continue.</p>
                        </div>
                      </Col>
                      <Col className="col-5 align-self-end">
                        <img src={profile} alt="" className="img-fluid" />
                      </Col>
                    </Row>
                  </div> */}
                  <div className="auth-logo">
                    <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <LogoContext.Consumer>
                            {({ companyLogo }) => (
                              <img
                                src={companyLogo || lightlogo}
                                alt="Company Logo"
                                className="rounded-circle"
                                height="34"
                              />
                            )}
                          </LogoContext.Consumer>
                        </span>
                      </div>
                    </Link>
                    <Link to="/" className="auth-logo-dark">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light logo">
                          <LogoContext.Consumer>
                            {({ companyLogo }) => {
                              return (
                                <img
                                  src={companyLogo || logo2}
                                  alt="Company Logo"
                                  className="rounded-circle"
                                  height="34"
                                />
                              );
                            }}
                          </LogoContext.Consumer>
                        </span>
                      </div>
                    </Link>
                  </div>
                  <CardBody className="pt-0">
                    <div className="p-2 login-form-settings">
                      <div className="text-primary p-4 welcome-cards">
                        <h5 className="text-primary">Welcome Back !</h5>
                        <p>Sign in to continue.</p>
                      </div>

                      <AvForm
                        className="form-horizontal"
                        // onValidSubmit={this.handleValidSubmit}
                      >
                        {this.state.errors ? (
                          <div
                            className="alert alert-danger fade show"
                            role="alert"
                            dangerouslySetInnerHTML={{
                              __html: this.state.errors,
                            }}
                          ></div>
                        ) : this.state.success ? (
                          <div
                            className="alert alert-success fade show"
                            role="alert"
                            dangerouslySetInnerHTML={{
                              __html: this.state.success,
                            }}
                          ></div>
                        ) : null}

                        {this.state.loginType === "username" && (
                          <>
                            <div className="mb-3">
                              <AvField
                                name="username"
                                label="Username"
                                value=""
                                className="form-control"
                                placeholder="Enter Username"
                                type="text"
                                required
                                errorMessage="Field can't be empty" // Custom error message
                                disabled={this.state.otpStatus}
                                onChange={e =>
                                  this.setState({ username: e.target.value })
                                }
                              />
                            </div>
                            <div className="mb-3 avfield-cards">
                              <AvField
                                name="password"
                                label="Password"
                                value=""
                                className="form-control"
                                placeholder="Enter password"
                                type={showPassword ? "text" : "password"} // Toggle password visibility
                                required
                                errorMessage="Field can't be empty" // Custom error message
                                onChange={e =>
                                  this.setState({ password: e.target.value })
                                }
                              />
                              <span onClick={this.togglePasswordVisibility}>
                                <FontAwesomeIcon
                                  icon={showPassword ? faEyeSlash : faEye}
                                />
                              </span>
                            </div>
                            <div className="mb-3">
                              <Label>Captcha</Label>

                              <div className="d-flex align-items-center gap-2">
                                {/* Captcha text */}
                                <div
                                  style={{
                                    minWidth: "125px",
                                    textAlign: "center",
                                    fontSize: "22px",
                                    fontWeight: "bold",
                                    letterSpacing: "4px",
                                    color: "#d81b60",
                                    background: "#f3f3f3",
                                    padding: "8px 12px",
                                    borderRadius: "4px",
                                    userSelect: "none",
                                    whiteSpace:"nowrap"
                                  }}
                                >
                                  {this.state.captchaText}
                                </div>

                                {/* Refresh */}
                                <button
                                  type="button"
                                  className="btn btn-light"
                                  onClick={this.refreshCaptcha}
                                  title="Refresh Captcha"
                                >
                                  ↻
                                </button>

                                {/* Input */}
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Captcha"
                                  value={this.state.captchaInput}
                                  onChange={e =>
                                    this.setState({
                                      captchaInput: e.target.value,
                                      captchaError: "",
                                    })
                                  }
                                />
                              </div>

                              {this.state.captchaError && (
                                <p className="text-danger mt-1">
                                  {this.state.captchaError}
                                </p>
                              )}
                            </div>
                          </>
                        )}

                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id="customControlInline"
                          />
                          <label
                            className="form-check-label"
                            htmlFor="customControlInline"
                          >
                            Remember me
                          </label>
                        </div>

                        <div className="mt-3 d-grid">
                          <button
                            className="btn btn-primary btn-block"
                            onClick={this.onSubmit}
                          >
                            {this.state.Buttonloading ? (
                              <Spinner size="sm" />
                            ) : (
                              "Sign in"
                            )}
                          </button>

                          <button
                            className="btn btn-primary border01 btn-block mt-3"
                            onClick={this.handleSSOLogin}
                            hidden
                          >
                            Login using NeuroTal SSO
                          </button>
                        </div>

                        {/* <div className="mb-3">
                            <AvField
                              name="password"
                              label="Password"
                              value=""
                              type="password"
                              required
                              placeholder="Enter Password"
                            />
                          </div> */}

                        {/* <div className="mt-3 d-grid">
                            <button
                              className="btn btn-primary btn-block"
                              type="submit"
                            >
                              Log In
                            </button>
                          </div> */}

                        {/* <div className="mt-4 text-center">
                            <Link to="/forgot-password" className="text-muted">
                              <i className="mdi mdi-lock me-1" /> Forgot your
                              password?
                            </Link>
                          </div> */}
                      </AvForm>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

Login.propTypes = {
  apiError: PropTypes.any,
  error: PropTypes.any,
  history: PropTypes.object,
  loginUser: PropTypes.func,
};

const mapStateToProps = state => {
  const { error } = state.Login;
  return { error };
};

export default withRouter(
  connect(mapStateToProps, { loginUser, apiError })(Login)
);
